// 英语
export default {
    /* 登录、注册 =======================================================0 */
    "登录": "Login",
    "注册": "Register",
    "忘记密码": "forget the password?",
    "没有账号？马上注册": "don't have an account? register now!",
    "请输入手机号": "please enter your mobile phone number",
    "请输入密码": "please enter your password",
    "请确认密码": "please confirm your password",
    "请输入邀请码": "please enter the invitation code",
    "密码确认失败，请重新设置": "password confirmation failed, please reset",
    "登录中...": "logging in...",
    "登录成功": "login successful",
    "注册中...": "registration in progress...",
    "注册成功,即将跳转首页": "registration successful, you will be redirected to the homepage shortly.",
    "我已经知晓并同意开户协议各项条约": "i have read and agree to all terms and conditions of the account opening agreement",
    "请阅读并同意开户协议": "please read and agree to the account opening agreement",
    "已有账号？马上登录": "already have an account? log in now",
    "请联系在线客服": "please contact online customer service",
    /* 登录、注册 =======================================================1 */

    /* 首页 ============================================================0 */
    "首页": "home",
    "请选择地区": "please select region",
    "全国第一福利品": "the No.1 welfare product in the country",
    "为了会员权益，网站只展示 1% 资源并且不定期更新只为展示实力，如需查询预约更多资源请联系上级接待": "to protect member benefits, the website only displays 1% of its resources and updates them irregularly to showcase its capabilities. For inquiries or reservations of more resources, please contact your immediate supervisor.",
    "本平台所有资源真实、安全、可靠，全国空降、同城约炮选取你心仪的她，与您零距离邂逅，快加入我们吧": "all resources on this platform are genuine, safe, and reliable. We offer nationwide meetups and same-city hookups. Choose your ideal partner and connect with her up close. Join us now!",
    "平台资源": "platform resources",
    "昵称": "nick name:",
    "类型": "type:",
    "距离：点击查看": "distance: click to view",
    "服务项目：激活可见": "services: activation required",
    "已认证": "authenticated",
    "查看更多": "view more",
    "当前地区暂无资源": "there are currently no resources available in this area",
    "服务条款": "terms of service",
    "网红、模特、空姐、嫩模、大学生、留学生，只有您想不到，没有本平台办不到": "Internet celebrities, models, flight attendants, young models, college students, international students—if you can imagine it, this platform can provide it.",
    "服务范围": "service scope",
    "同城约炮，任意地点空降，国内一二线城市当地均有，三线城市也可以通过上级预约安排": "Local hookups, drop-off anywhere, available in first and second-tier cities across China, and even third-tier cities can be arranged through a superior.",
    "热门地区": "popular areas",
    "更多地区": "more regions",
    "网红、模特、空姐、嫩模、大学生、留学生": ['Internet Celebrity', 'Model', 'Flight Attendant', 'Young Model', 'College Student', 'International Student'],
    "请联系管理员激活账号": "please contact the administrator to activate your account",
    "请联系客服获取更多信息": "please contact customer service for more information",
    /* 首页 ============================================================1 */

    /* 福利 ============================================================0 */
    "福利": "welfare",
    "全部": "all",
    /* 福利 ============================================================1 */

    /* 视频 ============================================================0 */
    "视频": "video",
    /* 视频 ============================================================1 */

    /* 我的 ============================================================0 */
    "我的": "mine",
    "余额": "Balance",
    "元": "dollar",
    "¥": "$",
    "CNY": "USD",
    "我的信用分": "My Credit Score",
    "我的客服": "Customer Service",
    "提现": "Withdrawal",
    "提现记录": "Withdrawal Records",
    "个人报表": "Personal Report",
    "任务记录": "Task Log",
    "我的消息": "My Message",
    "银行卡": "Bank Card",
    "设置": "Setting",
    "未配置跳转链接": "no redirect link configured",
    "功能尚未开放": "the feature is not yet available",
    /* 我的 ============================================================1 */

    /* 美女 ============================================================0 */
    "公告": "notice",
    "基本信息": "Basic Information",
    "生日": "birthday: ****year**month**day",
    "身高": "height: ***cm",
    "体重": "weight: ***kg",
    "胸围": "chest circumference: ***",
    "所在位置：已隐藏，联系客服激活可见": "location: Hidden. Contact customer service to activate and view.",
    "联系方式：已隐藏，联系客服激活可见": "contact information: Hidden. Contact customer service to activate and view.",
    "服务项目：激活可见": "services: Activation required",
    "祝愿各位会员每天都能遇到美好的恋情，享受快乐的夜晚": "Wishing all members a wonderful romance every day and a joyful night!",
    "立即约她": "Ask Her Out Immediately",
    "联系专属客服接待": "Contact your dedicated customer service representative.",
    /* 美女 ============================================================1 */

    /* 个人报表 ========================================================0 */
    "盈利金额": "profit amount",
    "盈利计算公式": "profit calculation formula",
    "任务金额": "Task Amount",
    "充值金额": "Recharge Amount",
    "提现金额": "Withdrawal Amount",
    "中奖金额": "Winning Amount",
    /* 个人报表 ========================================================1 */

    /* 播放器 ==========================================================0 */
    "播放器": "player",
    "热门推荐": "Popular Recommendations",
    "提示": "hint",
    "播放次数已用完，请联系专属客服": "play count exhausted. please contact our dedicated customer service",
    /* 播放器 ==========================================================1 */

    /* 下注 ===========================================================0 */
    "彩票": "lottery",
    "查看历史开奖": "Historical Records",
    "开奖期数": "number of draws",
    "中奖号码": "winning numbers",
    "下单": "pay",
    "下注号码": "betting numbers",
    "请选择下注号码": "please select the numbers to bet on",
    "每注金额": "amount per bet",
    "请输入金额": "please enter the amount",
    "总计": "total",
    "订单": "order",
    "清空": "clear",
    "余额不足，请联系客服充值": "insufficient balance. please contact customer service to top up!",
    "付款功能未开通，请联系在线客服": "payment functionality is not enabled. please contact online customer service",
    "付款中...": "Payment In Progress...",
    "付款成功": "Payment Successful",
    /* 下注 ===========================================================1 */

    /* 任务记录 =======================================================0 */
    "暂无记录": "no records available",
    "待开奖": "Lottery Draw Pending",
    "订单金额": "order amount:",
    "中奖金额": "prize amount:",
    "下注时间": "betting time:",
    "开奖时间": "lottery draw time:",
    "隐藏详情": "hide details",
    "查看详情": "check the details",
    "投注号码": "betting numbers:",
    "投注金额": "bet amount:",
    /* 任务记录 =======================================================1 */

    /* 银行卡 =========================================================0 */
    "银行名称": "bank name",
    "银行卡号": "bank card number",
    "持卡人姓名": "user name",
    "手机号": "mobile",
    "点击选择银行": "click to select bank",
    "请填写银行卡号": "please enter your bank card number",
    "请填写持卡人姓名": "please fill in the cardholder's name",
    "请填写预留手机号": "please fill in the mobile phone number you provided",
    "添加银行卡": "add bank card",
    "绑定银行卡": "bind bank card",
    "提示:请绑定大型商业银行, 如需修改, 请您联系在线客服": "note: please link your account to a major commercial bank. If you need to modify your account, please contact online customer service.",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "dear user, to ensure the safety of your funds, please bind your real name and set a withdrawal password. If the name does not match the account holder's name, you will not be able to withdraw funds.",
    "请绑定大型商业银行, 如需修改, 请您联系在线客服": "please link your account to a major commercial bank. For modifications, please contact our online customer service.",
    /* 银行卡 =========================================================1 */

    /* 提现 ===========================================================0 */
    "记录": "records",
    "限额说明": "quota explanation",
    "单笔交易最低限额": "minimum transaction amount",
    "单笔交易最高限额": "maximum transaction amount",
    "每天可提款次数": "daily withdrawal limit",
    "到账时间": "arrival time: Generally around 5 minutes, but can be as fast as within 2 minutes.",
    "请输入资金密码": "please enter your funds password",
    "请联系专属客服": "please contact your dedicated customer service representative",
    "取消": "cancel",
    "提交中...": "submitting...",
    "说明": "illustrate",
    "提交时间": "submission time",
    "审核时间": "review time",
    "审核中": "under review",
    /* 提现 ===========================================================1 */

    /* 设置 ===========================================================0 */
    "头像": "avatar",
    "点击选择头像": "click to select profile picture",
    "姓名": "name",
    "点击设置姓名": "click to set name",
    "性别": "gender",
    "男": "man",
    "女": "woman",
    "未知": "unknown",
    "点击选择性别": "click to select gender",
    "登录密码": "login password",
    "去修改": "go to modify",
    "资金密码": "funds code",
    "如需修改，请联系专属客服": "for modifications, please contact our dedicated customer service",
    "设置动词": "set up",
    "语言": "language",
    "切换语言": "switch language",
    "退出登录": "Log Out",
    "选择头像": "Select Avatar",
    "确定": "confirm",
    "设置姓名": "Set Name",
    "请输入您的姓名": "please enter your name",
    "请选择您的性别": "please select your gender",
    "你已设置姓名，如需修改，请联系专属客服": "You have already set your name. To change it, please contact your dedicated customer service representative.",
    /* 设置 ===========================================================1 */

    /* 选择语言 ===========================================================0 */
    "选择语言": "select language",
    "正在切换语言...": "switching languages...",
    /* 选择语言 ===========================================================1 */

    /* 修改登录密 =========================================================0 */
    "修改登录密码": "change login password",
    "旧密码": "old password",
    "请输入旧密码": "please enter your old password",
    "新密码": "new password",
    "请输入新密码": "please enter your new password",
    "确认密码": "confirm password",
    "请确认新密码": "please confirm your new password",
    "修改": "revise",
    "修改中...": "under modification...",
    "修改成功，请重新登录": "modification successful, please log in again",
    /* 修改登录密 =========================================================1 */

    /* 设置资金密码 =======================================================1 */
    "设置资金密码": "set a password for funds",
    "资金密码必须由四位数字组成": "the password for funds must consist of four digits",
    "设置中...": "setting up...",
    "设置成功": "setup successful",
    /* 设置资金密码 =======================================================1 */
}